import type { UseFormReturn } from 'react-hook-form';

import type { AnalysisUnitOption, MetricForm } from '../../../CreateMetricModal/formUtils';

/** Analysis unit `onSelect` handler shared by the simple and ratio sections. */
export function createAnalysisUnitsSelectHandler(context: UseFormReturn<MetricForm>) {
  const isEditingPersistedMetric = Boolean(context.formState.defaultValues?.key);

  return (selection: string[], options: AnalysisUnitOption[], meta?: { isAutoSelected?: boolean }) => {
    const selected = options.filter((option) => selection.includes(option.value));
    // An auto-selected unit is a real change on a persisted metric, but not on a metric being created.
    const shouldDirty = !meta?.isAutoSelected || isEditingPersistedMetric;

    context.setValue('analysisUnits', selected, { shouldDirty });
  };
}
